<script setup lang="ts">
const { locale, localePath } = useAppI18n()

type HotSurveyItem = {
  urlPath: string
  cover?: string
  cover_survey348?: string
  title?: string
  isexhibition?: boolean
  [key: string]: unknown
}

/** 组件入参，热门实勘列表由父组件传入。 */
const props = withDefaults(
  defineProps<{
    hotSurveyList?: HotSurveyItem[]
  }>(),
  {
    hotSurveyList: () => [],
  },
)

/** 固定展示前三条热门实勘，避免超出设计稿布局。 */
const visibleHots = computed(() => props.hotSurveyList.slice(0, 3))

/** 按实勘类型分流热门卡片详情页路由名。 */
const resolveDetailRouteName = (item: HotSurveyItem) => {
  return item?.isexhibition ? 'inspections-expo-exchange-slug' : 'inspections-exchange-slug'
}
</script>

<template>
  <div v-if="visibleHots.length" class="grid w-full grid-cols-3 gap-[16px]">
    <NuxtLink
      v-for="item in visibleHots"
      :to="
        localePath({
          name: resolveDetailRouteName(item),
          params: {
            slug: item.urlPath,
          },
        })
      "
      :key="item.urlPath"
      target="_blank"
      class="group relative block min-w-0 overflow-hidden rounded-[8px] text-left"
    >
      <CommonImage
        :src="item.cover_survey348 || item.cover"
        :alt="item.title || ''"
        class="block !h-auto !w-full object-cover"
        loading="lazy"
      />
      <div
        class="absolute right-0 bottom-0 left-0 z-[2] flex items-center justify-start rounded-br-[8px] rounded-bl-[8px] bg-[rgba(5,12,31,0.46)] px-[8px] py-[4px] text-center group-hover:bg-[rgba(5,12,31,0.62)]"
      >
        <p class="w-full overflow-hidden text-[12px] leading-[18px] text-ellipsis whitespace-nowrap text-white">
          {{ item.title }}
        </p>
      </div>
    </NuxtLink>
  </div>
</template>
